import React from 'react'
import ReactMarkdown from 'react-markdown'
import Button from '@SiteComponents/Button'
import AlertInfo from '@Images/alert_info.svg'

import './Alert.scss'

interface AlertProps {
  readonly message: string
  readonly linkLabel?: string
  readonly linkUrl?: string
  readonly marginTop?: number
  close(): void
}

const DEFAULT_LINK_LABEL = 'Learn more'
const DEFAULT_LINK_URL = 'https://support.checksub.com/changelog'

const Alert: React.FC<AlertProps> = props => {
  const {
    message,
    linkLabel,
    linkUrl,
    marginTop,
  } = props

  const shouldUseStyle = typeof(marginTop) === 'number'

  const style = shouldUseStyle ? {
    marginTop: `${marginTop}px`
  } : {}

  const messageSplit = message.split('\n')
  const messageHeader = messageSplit[0]
  const messageText = messageSplit.slice(1).join('\n')

  return (
    <div
      className="Alert"
      style={style}
    >
      <AlertInfo />
      <div className="Alert__right">
        <div className="Alert__header">
          <ReactMarkdown>
            {messageHeader}
          </ReactMarkdown>
        </div>
        <div className="Alert__right-bottom">
          <div className="Alert__text">
            {messageText}
            <a href={linkUrl || DEFAULT_LINK_URL} target="_blank" rel="noreferrer">
              <ReactMarkdown>{linkLabel || DEFAULT_LINK_LABEL}</ReactMarkdown>
            </a>
          </div>
          <Button
            caption="Close"
            onClick={props.close}
            styleType="gray"
            size="small"
          />
        </div>
      </div>
    </div>
  )
}

export default Alert
